import { __decorate } from "tslib";
import { injectable } from '@patsnap/tahiti-core/shared/inversify';
import { AbstractSelectionManager } from '@cores/services/selection-manager';
let SelectSpacesServiceImpl = class SelectSpacesServiceImpl extends AbstractSelectionManager {
    identify(element) {
        return element.spaceId;
    }
};
SelectSpacesServiceImpl = __decorate([
    injectable()
], SelectSpacesServiceImpl);
export { SelectSpacesServiceImpl };
